import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-video-not-published',
  templateUrl: './video-not-published.component.html',
  styleUrls: ['./video-not-published.component.scss']
})
export class VideoNotPublishedComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal) { }
  @Input() public message;
  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }
}

